// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_loginContainer__32cQc {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f4f6f9;
  padding: 1rem;
}

.Login_loginCard__v2cjW {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 400px;
}

.Login_loginTitle__txhRz {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
}

.Login_loginForm__1kk93 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Login_errorMessage__TCZLP {
  color: #6c757d;
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.Login_loadingText__C0Az8 {
  margin-top: 1rem;
  color: #6c757d;
}

.Login_submittingOverlay__5O7HU {
  text-align: center;
  margin-top: 1rem;
  color: #007bff;
}
.Login_submittingOverlay__5O7HU p {
  margin-top: 0.5rem;
}

.Login_forgotPassword__Z5vx1 {
  text-align: center;
  cursor: pointer;
  color: #666;
}
.Login_forgotPassword__Z5vx1:hover {
  text-decoration-line: underline;
  color: var(--orange);
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AACJ;;AAGA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;;AAGA;EACI,cAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAEI;EACI,kBAAA;AAAR;;AAIA;EACI,kBAAA;EACA,eAAA;EACA,WAAA;AADJ;AAEI;EACI,+BAAA;EACA,oBAAA;AAAR","sourcesContent":[".loginContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    background-color: #f4f6f9;\r\n    padding: 1rem;\r\n    \r\n}\r\n  \r\n.loginCard {\r\n    background-color: #fff;\r\n    padding: 2rem;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.08);\r\n    width: 100%;\r\n    max-width: 400px;\r\n}\r\n\r\n.loginTitle {\r\n    font-size: 1.8rem;\r\n    font-weight: 600;\r\n    margin-bottom: 1.5rem;\r\n    color: #333;\r\n    text-align: center;\r\n}\r\n\r\n.loginForm {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.errorMessage {\r\n    color: #6c757d;\r\n    margin-bottom: 2rem;\r\n    padding: 1rem;\r\n    background-color: #f8f9fa;\r\n    border-radius: 8px;\r\n    border: 1px solid #e9ecef;\r\n}\r\n\r\n.loadingText {\r\n    margin-top: 1rem;\r\n    color: #6c757d;\r\n}\r\n\r\n.submittingOverlay {\r\n    text-align: center;\r\n    margin-top: 1rem;\r\n    color: #007bff;\r\n    \r\n    p {\r\n        margin-top: 0.5rem;\r\n    }\r\n}\r\n\r\n.forgotPassword{\r\n    text-align: center;\r\n    cursor: pointer;\r\n    color: #666;\r\n    &:hover {\r\n        text-decoration-line: underline;\r\n        color: var(--orange);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `Login_loginContainer__32cQc`,
	"loginCard": `Login_loginCard__v2cjW`,
	"loginTitle": `Login_loginTitle__txhRz`,
	"loginForm": `Login_loginForm__1kk93`,
	"errorMessage": `Login_errorMessage__TCZLP`,
	"loadingText": `Login_loadingText__C0Az8`,
	"submittingOverlay": `Login_submittingOverlay__5O7HU`,
	"forgotPassword": `Login_forgotPassword__Z5vx1`
};
export default ___CSS_LOADER_EXPORT___;
